import React from 'react';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';

export default function ModalPeriodesExpirees({ periodes, onTraiter, onIgnorer, onClose }) {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-xl shadow-xl max-w-2xl w-full p-6 mx-4">
        <div className="flex items-start gap-4 mb-6">
          <div className="flex-shrink-0">
            <ExclamationTriangleIcon className="h-12 w-12 text-honey-500" />
          </div>
          <div className="flex-1">
            <h3 className="text-xl font-semibold text-gray-900 mb-2">
              Périodes expirées détectées
            </h3>
            <p className="text-gray-600 text-sm">
              Les périodes suivantes sont dépassées et nécessitent un traitement avant de pouvoir modifier la composition.
            </p>
          </div>
        </div>
        
        <div className="mb-6 bg-honey-50 rounded-lg p-4 border border-honey-200">
          <h4 className="text-sm font-medium text-honey-900 mb-3">
            Fractions concernées :
          </h4>
          <ul className="space-y-2">
            {periodes.map(p => (
              <li key={p._id} className="flex items-center justify-between text-sm">
                <span className="flex items-center gap-2">
                  <span className="px-3 py-1 bg-honey-100 text-honey-800 rounded-full font-medium">
                    {p.fraction.replace('_', ' ').replace('er', 'er').replace('e', 'e')}
                  </span>
                </span>
                <span className="text-gray-700">
                  Période {p.periodeDebut}-{p.periodeFin}
                </span>
              </li>
            ))}
          </ul>
        </div>
        
        <div className="bg-blue-50 rounded-lg p-4 mb-6 border border-blue-200">
          <p className="text-sm text-blue-900">
            <strong>Que faire ?</strong> Vous devez traiter les membres sortants de ces fractions et incrémenter les périodes avant de pouvoir effectuer d'autres modifications.
          </p>
        </div>
        
        <div className="flex gap-3">
          <button
            onClick={onTraiter}
            className="flex-1 px-4 py-3 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 font-medium transition-colors"
          >
            Traiter les périodes expirées
          </button>
          <button
            onClick={onIgnorer}
            className="flex-1 px-4 py-3 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 font-medium transition-colors"
          >
            Modifier d'autres sections
          </button>
        </div>
      </div>
    </div>
  );
}
